<script>
import Layout from '@layouts/main'
import DocumentNew from './document-new'
import DocumentChangeNew from './document-change-new'
import DocumentReturnsNew from './document-returns-new'
import DocumentDelete from './document-delete'
import Filters from '@views/filters-dialog'
import documentModel from '@src/models/document'
import TablePaginator from '@components/paginator'
import userHasRolesToWrite from '@utils/userPermissions'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'
import { hideValues, updateColumns } from '@utils/helpers/columns'

export default {
  name: 'Documents',
  metaInfo: {
    title: 'Documents',
    meta: [{ name: 'description', content: 'Documents' }],
  },
  components: {
    Layout,
    DocumentNew,
    DocumentChangeNew,
    DocumentReturnsNew,
    DocumentDelete,
    Filters,
    TablePaginator,
    AdjustColumnsDialog,
  },
  data() {
    return {
      headers: [
        {
          text: 'type',
          value: 'type',
          sortable: true,
          width: '10%',
          show: true,
        },
        { text: 'number', value: 'number', sortable: true, width: '10%' },
        {
          text: 'date',
          value: 'date',
          sortable: true,
          width: '10%',
          show: true,
        },
        {
          text: 'from',
          value: 'from',
          sortable: true,
          width: '10%',
          show: true,
        },
        {
          text: 'fromWarehouse',
          value: 'fromWarehouse',
          sortable: true,
          width: '10%',
          show: true,
        },
        { text: 'to', value: 'to', sortable: true, width: '10%', show: true },
        {
          text: 'toWarehouse',
          value: 'toWarehouse',
          sortable: true,
          width: '10%',
          show: true,
        },
        {
          text: 'status',
          value: 'status',
          sortable: true,
          width: '10%',
          show: true,
        },
        {
          text: 'owner',
          value: 'ownerId',
          sortable: true,
          width: '10%',
          show: true,
        },
        { text: 'actions', value: 'actions', sortable: false, width: '10%' },
      ],
      isLoading: true,
      rowsPerPage: [10, 25, 50],
      rolesAllowedToCreate: ['SUPERUSER', 'DOCUMENTS_OPERATOR'],
      page: 1,
      totalPages: 0,
      sortBy: 'number',
      descending: true,
      first: false,
      last: false,
      content: [],
      pagination: {},
      newDocument: false,
      showFilters: false,
      multiSelect: true,
      model: documentModel,
      showDialog: false,
      filters: null,
      fab: false,
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending || null,
        ...this.filters,
      }
    },
    userAllowedToCreate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToCreate
      )
    },
    getHeaders() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToCreate
      )
        ? this.headers
        : this.headers.slice(0, this.headers.length - 1)
    },
    isChangeDocument() {
      return this.$route.params.documentType === 'change'
    },
    isReturnsDocument() {
      return this.$route.params.documentType === 'returns'
    },
  },
  watch: {
    pagination: {
      handler() {
        this.$store.commit('pagination/SET', {
          name: this.$route.params.documentType,
          pagination: {
            page: this.page,
            rowsPerPage: this.pagination.rowsPerPage,
            sortBy: this.sortBy,
            descending: this.descending,
          },
        })
      },
      deep: true,
    },
  },
  created() {
    this.getPaginator()
    this.getFilters()
  },
  methods: {
    fetchData() {
      this.isLoading = true
      const payload = {
        name: this.$route.params.documentType || null,
        params: this.params,
      }
      this.$store.dispatch('data/fetchData', payload).then(response => {
        this.content = response.content
        this.totalPages = response.totalPages
        this.first = response.first
        this.last = response.last
        this.page = response.number + 1
        this.pagination = {
          ...this.pagination,
          page: 1,
          rowsPerPage: response.size,
          sortBy: this.sortBy,
          descending: this.descending,
        }
        this.isLoading = false
      })
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    openDocument(id) {
      const documentType = this.$route.params.documentType
      this.$router.push(`${documentType}/${id}`)
    },
    documentCreated() {
      this.fetchData()
    },
    getFilters() {
      const filter = this.$store.getters['filters/getFilters'](
        this.$route.params.documentType
      )
      this.filters = filter ? filter.value : null
      this.fetchData()
    },
    setFilters() {
      const filter = this.$store.getters['filters/getFilters'](
        this.$route.params.documentType
      )
      this.filters = filter ? filter.value : null
      this.showFilters = false
      this.page = 1
      this.fetchData()
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](
        this.$route.params.documentType
      )
      if (pagination) {
        this.page = pagination.page || 1
        this.sortBy = pagination.sortBy || this.sortBy
        this.descending = pagination.descending || false
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.page = 1
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    changePage(value) {
      this.page = value
      this.fetchData()
    },
    changeRowsPerPage(value) {
      if (this.pagination.rowsPerPage === value) return
      this.pagination = {
        ...this.pagination,
        rowsPerPage: value,
      }
      this.page = 1
      this.$store.dispatch('pagination/saveRowsPerPage', value)
      this.fetchData()
    },
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.fetchData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
    hideValues(field) {
      return hideValues(field, this.headers)
    },
    updateColumns(columns) {
      updateColumns(columns, this.headers)
    },
    openDialog() {
      this.showDialog = true
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="actionButton">
      <div class="hidden-xs-only">
        <v-btn
          color="info"
          @click="fetchData"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn
          :color="filters ? `success` : `info`"
          @click="showFilters = true"
        >
          <v-icon>filter_list</v-icon>
        </v-btn>
        <v-btn
          v-if="userAllowedToCreate"
          slot="activator"
          color="primary"
          dark
          @click.native.stop="newDocument = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </div>
      <div class="hidden-sm-and-up">
        <v-speed-dial
          v-model="fab"
          direction="left"
          transition="slide-y-reverse-transition"
        >
          <v-btn
            slot="activator"
            v-model="fab"
            color="blue darken-2"
            dark
            fab
            small
            flat
          >
            <v-icon>more_vert</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            dark
            small
            fab
            @click.native.stop="newDocument = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
            :color="filters ? `success` : `info`"
            small
            fab
            @click="showFilters = true"
          >
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-btn
            color="info"
            small
            fab
            @click="fetchData"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-speed-dial>
      </div>
    </div>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in getHeaders"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            {{ $t(`label__${header.text}`) }}
            <v-icon
              v-if="header.sortable"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :class="$style.sdEditRow"
          @click="openDocument(props.item.id)">
          <td v-if="!hideValues('type')">{{ $t(`documenttype.${props.item.type}.name`) }}</td>
          <td>{{ props.item.number }}</td>
          <td v-if="!hideValues('date')">{{ props.item.date }}</td>
          <td v-if="!hideValues('from')">{{ getValue('organization', props.item.from) }}</td>
          <td v-if="!hideValues('fromWarehouse')">{{ getValue('organization', props.item.fromWarehouse) }}</td>
          <td v-if="!hideValues('to')">{{ props.item.type === 5 ? '-' : getValue('organization', props.item.to) }}</td>
          <td v-if="!hideValues('toWarehouse')">{{ props.item.type === 5 ? '-' : getValue('organization', props.item.toWarehouse) }}</td>
          <td v-if="!hideValues('status')">{{ $t(`documentstatus.${props.item.status}.name`) }}</td>
          <td v-if="!hideValues('ownerId')">{{ getValue('user', props.item.ownerId) }}</td>
          <td v-if="userAllowedToCreate">
            <document-delete
              v-if="props.item.status !== 2"
              :document-id="props.item.id"
              :document-number="props.item.number"
              @document-deleted="fetchData(params)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="$route.params.documentType"
      @columns-updated="updateColumns"
    />
    <document-change-new
      v-if="isChangeDocument"
      :dialog="newDocument"
      @document-created="documentCreated"
      @close-modal="newDocument = false" />
    <document-returns-new
      v-if="isReturnsDocument"
      :dialog="newDocument"
      @add-document="fetchData(params)"
      @close-modal="newDocument = false" />
    <document-new
      v-if="!isChangeDocument && !isReturnsDocument"
      :new-document="newDocument"
      @close-modal="newDocument = false" />
    <filters
      :visible="showFilters"
      :model="model"
      :model-name="$route.params.documentType"
      :multi-select="multiSelect"
      @close-modal="showFilters = false"
      @filters-confirmed="setFilters()"
    />
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
</style>
